import React from 'react';
import FormPage from '../shared/FormPage';
import useCreateCompanyStore from '../../stores/createCompanyStore';

const WelcomePage = () => {
  const { nextStep } = useCreateCompanyStore();
  return (
    <FormPage
      title="Welcome! 👋"
      subtitle="Let's get your company set up in just a few steps"
      inputType="none"
      onNext={nextStep}
      showPrevious={false}
      nextButtonText="Get Started"
    >
      <div className="text-center space-y-6">
        <div className="w-20 h-20 bg-violet-100 rounded-full flex items-center justify-center mx-auto">
          <svg className="w-10 h-10 text-violet-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
          </svg>
        </div>
        <div className="space-y-3">
          <p className="text-gray-600">
            We'll help you create your company profile and set up your admin account.
          </p>
          <p className="text-sm text-gray-500">
            This should only take a couple of minutes.
          </p>
        </div>
      </div>
    </FormPage>
  );
};

export default WelcomePage;
